import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter, Link } from 'react-router-dom';
import { List, ListItem, Divider } from 'material-ui';
import moment from 'moment';
import {
  PlacesRoomService,
  ActionBuild,
  CommunicationVpnKey,
  ActionSettings,
  CommunicationChat,
} from 'material-ui/svg-icons/';
import UserProfile from './UserProfile';
import HasPermissions from './HasPermissions';
import { AffiliateType } from '../types/index';
import { LocationType } from '../types/router';
import { localize } from '../i18n';
import ChatCounter from './ChatCounter';
import { Features } from '../utils';
import GtmService from '../services/GtmService';

const colors = {
  green: 'rgb(119, 156, 43)',
  black: 'rgb(68, 68, 68)',
  lightGrey: 'rgb(235, 235, 235)',
  darkBlue: 'rgb(4, 30, 43)',
};

const styles = {
  activeLink: {
    backgroundColor: colors.lightGrey,
    color: colors.green,
  },

  headerBlock: {
    padding: '8px 16px',
    backgroundColor: colors.darkBlue,
    backgroundSize: '100px 100px',
  },

  affiliateTitle: {
    margin: '1.2em 0',
    color: 'white',
  },

  title: {
    color: 'white',
  },

  copyRights: {
    display: 'block',
    textAlign: 'center',
    margin: '8px 16px',
    lineHeight: '12px',
    fontSize: '10px',
    color: '#bdbdbd',
  },

  counter: {
    position: 'absolute',
    right: 16,
    top: 12,
    width: 22,
    height: 22,
    backgroundColor: 'rgb(195, 31, 59)',
    lineHeight: '22px',
    textAlign: 'center',
    fontSize: '12px',
    color: 'white',
    borderRadius: '12px',
    margin: '1px',
    fontWeight: 'bold',
  },
};

const NavigationItem = withRouter((props) => {
  const {
    to,
    permission,
    onClick,
    location: {
      pathname,
    },
    children,
    icon: Icon,
    rightElement,
    primaryText,
  } = props;

  const restProps = _.pick(props, ['leftIcon', 'primaryText']);

  const active = pathname.indexOf(to) === 0;

  const getLinkItem = () => (
    <Link
      to={to}
      onClick={() => {
        GtmService.dataLayer({
          category: 'Navigation',
          action: 'Navigate To Section',
          label: primaryText,
        });
        onClick();
      }}
    >
      <ListItem
        {...restProps}
        style={active ? styles.activeLink : {}}
        leftIcon={<Icon color={active ? colors.green : colors.black} />}
        rightIcon={rightElement}
      >
        {children}
      </ListItem>
    </Link>
  );

  return (
    permission ?
      <HasPermissions permissions={permission}>{getLinkItem()}</HasPermissions> :
      getLinkItem()
  );
});

NavigationItem.propTypes = {
  to: PropTypes.string,
  permission: PropTypes.string,
  onClick: PropTypes.func,
  location: LocationType,
  rightElement: PropTypes.node,
};

const NavigationMenu = props => (
  <div className="uk-flex uk-flex-column uk-height-1-1">
    <div className="uk-flex-item-1">
      <div style={styles.headerBlock}>
        <h3 style={styles.affiliateTitle}>
          {props.affiliate.attributes.name}
        </h3>

        <UserProfile showUsername color="white" />
      </div>

      <List>
        <NavigationItem
          permission="service_requests.list"
          onClick={props.onNavigate}
          to="/access/requests"
          icon={PlacesRoomService}
          primaryText={props.t('Requests')}
        />

        <NavigationItem
          permission="work_orders.list"
          to="/access/workorders"
          icon={ActionBuild}
          onClick={props.onNavigate}
          primaryText={props.t('Work Orders')}
        />

        <NavigationItem
          permission="locations.list"
          to="/access/rooms"
          icon={CommunicationVpnKey}
          onClick={props.onNavigate}
          primaryText={props.t('Rooms')}
        />

        <Features has="chat">
          <NavigationItem
            permission="chat.full"
            to="/access/chat"
            icon={CommunicationChat}
            onClick={props.onNavigate}
            rightElement={<ChatCounter type="total" customStyle={styles.counter} />}
            primaryText="Chat"
          />
        </Features>
      </List>
      <Divider />
      <List>
        <NavigationItem
          to="/access/settings"
          icon={ActionSettings}
          onClick={props.onNavigate}
          primaryText={props.t('Settings')}
        />
      </List>
    </div>
    <div className="uk-flex-item-none">
      <span style={styles.copyRights}>
        TM & &copy; {moment().year()} {props.t('Project Cloudkey Inc.')}<br />
        {props.t('All rights reserved.')}
      </span>
    </div>
  </div>
);

NavigationMenu.propTypes = {
  affiliate: AffiliateType,
  onNavigate: PropTypes.func,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = ({ session: { affiliate } }) => ({ affiliate });

export default localize(connect(mapStateToProps)(NavigationMenu));



// WEBPACK FOOTER //
// ./src/components/NavigationMenu.js